<!--动态图对象 右键属性-->
<template>
  <div>
    <gs-modal v-model="visible" :before-close="beforeClose" :before-confirm="beforeConfirm" title="门禁管理" width="60%"
      top="10%" :has-form="true" class="my-test-class" @close="close" @confirm="handleConfirm">
      <gs-tabs v-model="activeName" type="content-tab">
        <gs-tab-pane label="操作" name="first">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column v-if="show === 'user'" prop="userId" label="ID" width="100">
            </el-table-column>
            <el-table-column v-if="show === 'user'" prop="username" label="名称" width="300">
            </el-table-column>
            <el-table-column v-if="show === 'user'" prop="userEnum" label="属性" width="200">
            </el-table-column>
            <el-table-column v-if="show === 'group'" prop="groupId" label="ID" width="200">
            </el-table-column>
            <el-table-column v-if="show === 'group'" prop="groupName" label="名称" width="200">
            </el-table-column>
            <el-table-column v-if="show === 'door'" prop="id" label="ID" width="100">
            </el-table-column>
            <el-table-column v-if="show === 'door'" prop="cardId" label="门卡ID" width="200">
            </el-table-column>
            <el-table-column v-if="show === 'door'" prop="createDate" label="创建时间" width="200">
            </el-table-column>
            <el-table-column v-if="show === 'door'" prop="tag" label="状态" width="200">
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <!-- <a @click="handleClick(scope.row)" type="text">删除</a>-->
                <a @click="record(scope.row)" type="text">查看记录</a>
                <a v-if="show === 'user'" @click="record(scope.row)" type="text">查看门禁卡</a>
                <a v-if="show === 'group'" @click="record(scope.row)" type="text">查看用户</a>
                <a @click="record(scope.row)" type="text">修改</a>
                <a @click="record(scope.row)" type="text">删除</a>
                <a @click="record(scope.row)" type="text">详情</a>
                <a @click="record(scope.row)" type="text">添加</a>
              </template>
            </el-table-column>
          </el-table>
          <div class="bottom-btn">
            <gs-button @click="getUserList">用户</gs-button>
            <gs-button @click="getUserGroupList">用户组</gs-button>
            <gs-button @click="getDoorList">门禁卡</gs-button>
            <!--<gs-button @click="add">添加</gs-button>-->
            <!-- <gs-button @click="renovateTopic">刷新</gs-button>-->
          </div>
        </gs-tab-pane>
        <!--<gs-tab-pane
          label="记录"
          name="list"
        ></gs-tab-pane>-->
      </gs-tabs>
    </gs-modal>
    <gs-modal v-model="dialogVisible" :before-close="beforeCloseAddTopic" title="记录" @close="close"
      @confirm="handleConfirmAddTopic">

    </gs-modal>
  </div>
</template>

<script type="text/ecmascript-6">
import { mapState, mapMutations } from 'vuex'
import service from '../../service/leftService.js'
import authorService from '../../service/authorityService'
export default {
  components: {

  },
  data() {
    return {
      show: 'user',
      activeName: 'first',
      inputTopic: '',
      dialogVisible: false,
      visibleAdd: false,
      visibleProperties: false,
      tableData: [],
      multipleSelection: []
    }
  },
  computed: {
    ...mapState({
      visible: 'doorShow',
      nodeData: 'objectInfo'
    })
  },
  watch: {
  },
  created() {
    this.show = "user"
    if (localStorage.getItem("Authorization")) {
      authorService.getUserListDoor().then(res => {
        this.tableData = res
      }).catch(err => {
        console.info(err)
      })
    }

  },
  mounted() {

  },
  methods: {
    ...mapMutations({
      close: 'DOOR_HIDE',
      needReload: 'DOOR_TREE'
    }),
    // 门禁列表
    getDoorList() {
      this.show = "door"
      authorService.getDoorList().then(res => {
        this.tableData = res
        console.log(res)
      }).catch(err => {
        this.tableData = err
        console.log(err)
      })
    },
    // 查看记录
    record() {
      this.dialogVisible = true
    },
    getUserList() {
      this.show = 'user'
      authorService.getUserListDoor().then(res => {
        this.tableData = res
        console.info(res)
      }).catch(err => {
        console.log(err)
      })
    },
    getUserGroupList() {
      this.show = 'group'
      authorService.getUserGroupListDoor().then(res => {
        this.tableData = res
        console.info(res)
      }).catch(err => {
        console.log(err)
      })
    },
    beforeClose() {
      this.close()
    },
    beforeCloseAddTopic() {
      this.dialogVisible = false
    },
    handleConfirmAddTopic() {
      let arr = []
      let topic = this.inputTopic
      arr.push(topic)
      service.addTopic(arr).then(resd => {
        service.findAllTopic().then(res => {
          this.$Message.success("添加成功")
          this.tableData = res
          this.inputTopic = ''
        }).catch(err => {
          this.inputTopic = ''
          this.$Message.error("查询失败")
          console.log(err)
        })
      }).catch(err => {
        this.inputTopic = ''
        this.$Message.error("添加失败")
        console.log(err)
      })

      this.dialogVisible = false
    },
    beforeConfirm(e, done) {
      if (this.name === null || this.name === '') {
        this.$Message.warning('名称不能为空!')
        return
      }
      if (!this.form.primaryY_autoScale) {
        if (this.form.primaryY_Mininum >= this.form.primaryY_maximum) {
          this.$Message.warning('Y轴最小值必须小于最大值')
          return
        }
      }
      if (!this.form.secondaryY_autoScale) {
        if (this.form.secondaryY_Mininum >= this.form.secondaryY_maximum) {
          this.$Message.warning('Y轴最小值必须小于最大值')
          return
        }
      }
      // done(false)可以阻止modal关闭
      done()
    },
    handleConfirm() {
      let _this = this
      this.loading = true
      let arr = []
      let backArr = JSON.parse(JSON.stringify(this.form.objectSeries))
      this.form.objectSeries.forEach(e => {
        arr.push(e.id)
      })
      this.form.objectSeries = arr
      if (this.objectInfo.id && this.objectInfo.type === 'onlineChart') {
        let param = {
          id: this.objectInfo.id,
          'name': this.name,
          'type': this.objectInfo.type,
          value: this.objectInfo.value,
          'parentId': this.objectInfo.parentId,
          'description': this.description,
          'attribute': this.form // 其他信息这里，键值对形式
        }
        service.renamePoint(param).then(res => {
          this.loading = false
          this.$Message.success('修改成功')
          _this.objectInfo.attribute.objectSeries = backArr
          this.close()
          this.objectInfo.name = this.name
          res.attribute.objectSeries = backArr
          this.$store.state.tabPanel = res
          this.$store.state.updateTreeNode = res
          this.description = ''
          this.name = ''
          // this.form = {
          //   objectSeries: []
          // }
          this.showList = []
          // eventBus.$emit('changeInterval', res)
        }).catch(err => {
          this.loading = false
          this.form.objectSeries = backArr
          console.log(err)
          //this.$Message.error(err.message)
        })
      } else {
        let param = {
          'name': this.name,
          'type': 'notebook',
          'parentId': this.objectInfo.id,
          'description': this.description,
          'attribute': this.form // 其他信息这里，键值对形式
        }
        service.newAddPoint(param).then(res => {
          this.loading = false
          this.$Message.success('添加成功')
          setTimeout(() => {
            res.attribute.objectSeries = backArr
            _this.$store.state.addTreeNode = res
          }, 0)
          this.close()
          this.description = ''
          this.name = ''
          // this.form = {
          //   objectSeries: []
          // }
          this.showList = []
        }).catch(err => {
          this.loading = false
          this.form.objectSeries = backArr
          console.log(err)
          // this.$Message.error(err.message)
        })
      }
    },
    handleClick(row) {
      let arr = []
      let topic = row.topic
      arr.push(topic)
      service.rmTopic(arr).then(resd => {
        service.findAllTopic().then(res => {
          this.tableData = res
          this.$Message.success("删除成功")
        }).catch(err => {
          this.$Message.error("删除更新失败!!!请手动刷新")
          console.log(err)
        })
      }).catch(err => {
        this.$Message.error("删除失败")
        console.log(err)
      })
    },
    add() {
      this.dialogVisible = true
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => { });
    },
    renovateTopic() {
      service.findAllTopic().then(res => {
        this.tableData = res
        this.$Message.success("刷新成功")
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>
<style scoped>
.my-test-class>>>.el-table .cell {
  padding-left: 9px;
  padding-right: 0px;
}

.bottom-btn {
  margin: 20px;
  text-align: center
}
</style>



// WEBPACK FOOTER //
// src/components/notebook/door.vue